
import barba from '@barba/core';
import tingle from 'tingle.js';

export default class{

	constructor(){
        barba.hooks.afterOnce((data) => {
            this.init()
        })
        barba.hooks.enter((data) => {
            this.init()
        });
    }
    init (){
        var modalContent = "";
        // instanciate new modal
        var modal = new tingle.modal({
            beforeClose: function() {
                // モダルの要素内を削除
                modal.setContent("");
                return true;
            }
        });
        var modalTrigger = document.querySelectorAll('[data-modal]');
        if(modalTrigger.length > 0){
            for (let i = 0; i < modalTrigger.length; i++) {
                var el = modalTrigger[i];
                _addModalEvent(el);
            }
        }
        function _addModalEvent(el){
            el.addEventListener('click',function(event){
                // 通常のクリックイベントをキャンセル
                event.preventDefault();
                var target = el.getAttribute('data-modal');
                var src = el.getAttribute('data-src');
                if(src!=""){
                    // .iframe-content要素を生成
                    var iframeContent = document.createElement('div');
                    iframeContent.setAttribute("class","iframe-content");
                    // iframe要素を生成
                    var iframe = document.createElement('iframe');
                    // 必要な属性を付与する
                    iframe.setAttribute("allow","autoplay; encrypted-media");
                    iframe.setAttribute("allowfullscreen","");
                    iframe.setAttribute("frameborder","0");
                    // src属性をセット
                    iframe.setAttribute("src",src);
                    // .iframe-content要素に追加
                    iframeContent.appendChild(iframe);
        
                    // modalにセット
                    modal.setContent(iframeContent);
                    // modalをopen
                    modal.open();
                }
            })
        }
    }
}